<template>
  <Layout>
    <div class="row mt-md-n3" v-if="userData.permissions['view_dashboard'] == 1">
      <div class="col-xl-12">
        <div class="d-flex justify-content-between mb-2">
          <h5 class="mt-4">
            <i class="mdi mdi-calendar"></i> {{ date }}'s Analysis
            <div class="text-primary ms-4 mt-1">{{ todayDate }}</div>
          </h5>
          <center v-if="loader">
            <b-spinner class="text-primary mt-4"></b-spinner>
          </center>
          <div class="d-flex justify-content-between mt-3">
            <div>
              <label class="mb-0">From</label>
              <input class="form-control" v-model="date_from" type="date" />
            </div>
            <div class="mx-1">
              <label class="mb-0">To</label>
              <input class="form-control" v-model="date_to" type="date" />
            </div>
            <div style="margin-top: 19px;">
              <b-button variant="primary" @click="filtered">
                <i class="mdi mdi-filter"></i> Filter
              </b-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="card mini-stats-wid" @click.prevent="$router.push('/viewsales')">
              <div class="card-body" style="cursor: pointer;"
                :class="{ 'bg-primary text-white rounded': cardHover == 1 }" @mouseover="cardHover = 1"
                @mouseleave="cardHover = 0">
                <div class="media">
                  <div class="media-body">
                    <p class="fw-medium mb-0" :class="{ 'text-light': cardHover == 1, 'text-muted': cardHover != 1 }">
                      Sales</p>
                    <h4 class="mb-0" :class="{ 'text-white': cardHover == 1 }">
                      {{ commas(payments) }} <small>UGX</small>
                    </h4>
                  </div>
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-title"><i class="mdi mdi-cash-multiple font-size-24"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card mini-stats-wid" @click.prevent="$router.push('/purchases')">
              <div class="card-body" style="cursor: pointer;"
                :class="{ 'bg-primary text-white rounded': cardHover == 2 }" @mouseover="cardHover = 2"
                @mouseleave="cardHover = 0">
                <div class="media">
                  <div class="media-body">
                    <p class="fw-medium mb-0" :class="{ 'text-light': cardHover == 2, 'text-muted': cardHover != 2 }">
                      Purchases</p>
                    <h4 class="mb-0" :class="{ 'text-white': cardHover == 2 }">
                      {{ commas(purchases) }} <small>UGX</small>
                    </h4>
                  </div>
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-title"><i class="mdi mdi-credit-card-scan font-size-24"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card mini-stats-wid" @click.prevent="$router.push('/viewexpenses')">
              <div class="card-body" style="cursor: pointer;"
                :class="{ 'bg-primary text-white rounded': cardHover == 3 }" @mouseover="cardHover = 3"
                @mouseleave="cardHover = 0">
                <div class="media">
                  <div class="media-body">
                    <p class="fw-medium mb-0" :class="{ 'text-light': cardHover == 3, 'text-muted': cardHover != 3 }">
                      Expenses</p>
                    <h4 class="mb-0" :class="{ 'text-white': cardHover == 3 }">
                      {{ commas(expenses) }} <small>UGX</small>
                    </h4>
                  </div>
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-title"><i class="bx bx-purchase-tag-alt font-size-24"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body row">
                  <div class="text-center fw-medium fs-5 mb-2">Expiry Summary Report</div>
                  <div @click="$router.push({ name: 'expiredstock', params: { activeTab: 1 } })"
                    style="cursor: pointer;" class="col-4 rounded" :class="{ 'shadow-sm': cardHover == 4 }"
                    @mouseover="cardHover = 4" @mouseleave="cardHover = 0">
                    <p class="text-danger fw-medium mb-1">Expired Batches</p>
                    <h4 class="mb-0">{{ expired }} <span v-if="typeof expired === 'number'">batches</span></h4>
                  </div>
                  <div @click="$router.push({ name: 'expiredstock', params: { activeTab: 2 } })"
                    style="cursor: pointer;" class="col-4 rounded" :class="{ 'shadow-sm': cardHover == 5 }"
                    @mouseover="cardHover = 5" @mouseleave="cardHover = 0">
                    <p class="text-warning fw-medium mb-1">Within 14 days</p>
                    <h4 class="mb-0">{{ in14Days }} <span v-if="typeof in14Days === 'number'">batches</span></h4>
                  </div>
                  <div @click="$router.push({ name: 'expiredstock', params: { activeTab: 3 } })"
                    style="cursor: pointer;" class="col-4 rounded" :class="{ 'shadow-sm': cardHover == 6 }"
                    @mouseover="cardHover = 6" @mouseleave="cardHover = 0">
                    <p class="text-muted fw-medium mb-1">Within 30 days</p>
                    <h4 class="mb-0">{{ in30Days }} <span v-if="typeof in30Days === 'number'">batches</span></h4>
                  </div>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-danger">
                  <span class="avatar-title">
                    <i class="mdi mdi-alert-circle font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card p-1">
              <div class="card-body p-1">
                <div class="h5 text-center">Products on Demand</div>
                <apexchart class="apex-charts" type="bar" height="300px" :options="monthlyservices.chartOptions"
                  :series="monthlyservices.series"></apexchart>
                <center>
                  <small style="margin-right: 10px;">Current Month:</small><b> {{ currentMonth }}</b>
                </center>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card px-1">
              <div class="card-body px-1 h-full">
                <div class="h5 text-center">Monthly Analysis</div>
                <b-tabs pills justified nav-class="p-0" content-class="text-primary">
                  <b-tab active class="p-0">
                    <template v-slot:title>Sales</template>
                    <apexchart class="apex-charts" type="line" height="260" :options="monthlypayments.chartOptions"
                      :series="monthlypayments.series"></apexchart>
                  </b-tab>
                  <b-tab class="p-0">
                    <template v-slot:title>Expenses</template>
                    <apexchart class="apex-charts" type="line" height="260" :options="monthlyexpenses.chartOptions"
                      :series="monthlyexpenses.series"></apexchart>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to view dashboard items</span>
            </center>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showModal" hide-footer centered header-class="border-0">
      <div class="text-center mb-4">
        <div class="avatar-md mx-auto mb-4">
          <div class="avatar-title bg-light rounded-circle text-primary h1">
            <i class="fas fa-cog fa-spin"></i>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-10">
            <h1 class="text-primary">System Update</h1>
            <p>
              Our System will be <b>OFF</b> on
              <b>15th January 2023 at 12:00 AM</b> for <b>30 minutes</b>. We
              shall be performing some updates. <br />
              Incase of any challenges, Please
              <a href="tel:+256779181146"> Call us</a>. otherwise we’ll be
              back online shortly!
            </p>
            <p class="h5">We apologize for any inconvenience.</p>
            <p>&mdash; The Afrimed Team</p>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { saleComputed, saleMethods, itemunitsMethods, itemunitsComputed } from "@/state/helpers";

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      date: "Today",
      todayDate: "",
      currentMonth: "",
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      purchases: 0,
      payments: 0,
      expenses: 0,
      date_from: new Date().toLocaleDateString("fr-CA"),
      date_to: new Date().toLocaleDateString("fr-CA"),
      services: [],
      yearlypayments: [],
      yearlyexpenses: [],
      monthlypayments: {
        series: [{ name: "Amount Paid", data: [] }],
        chartOptions: {
          noData: { text: "Please Wait..." },
          theme: { monochrome: { enabled: true, color: "#03967e" } },
        },
      },
      monthlyexpenses: {
        series: [{ name: "Amount Paid", data: [] }],
        chartOptions: {
          noData: { text: "Please Wait..." },
          theme: { monochrome: { enabled: true, color: "#03967e" } },
        },
      },
      monthlyservices: {
        series: [{ name: "Product", data: [] }],
        chartOptions: {
          noData: { text: "Please Wait..." },
          theme: { monochrome: { enabled: true, color: "#03967e" } },
        },
      },
      showModal: false,
      cardHover: 0,
      expired: '-',
      in14Days: '-',
      in30Days: '-',
      loader: true
    };
  },
  computed: {
    ...saleComputed,
    ...itemunitsComputed,
  },
  created() {
    this.fetchItemUnits();
    this.todaysanalysis();
    this.expiries();
    this.yearlyanalysis();
  },
  methods: {
    ...saleMethods,
    ...itemunitsMethods,
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getCurrentMonth() {
      return this.months[new Date().getMonth()];
    },
    getDatePart() {
      const today = new Date();
      return `${today.getDate()}/${this.months[today.getMonth()].substring(0, 3)}/${today.getFullYear()}`;
    },
    async todaysanalysis() {
      await axios.get(`/todaysanalysis`).then((response) => {
        this.purchases = response.data.purchases;
        this.expenses = response.data.expenses;
        this.payments = response.data.payments;
      });
    },
    async expiries() {
      await axios.get(`/expiries`).then((response) => {
        this.expired = response.data.expired;
        this.in14Days = response.data.in14Days;
        this.in30Days = response.data.in30Days;
        this.loader = false
      });
    },
    async filtered() {
      let formData = new FormData();
      formData.append("date_from", this.date_from);
      formData.append("date_to", this.date_to);
      await axios.post(`/filteredanalysis`, formData).then((response) => {
        this.expenses = response.data.expenses;
        this.payments = response.data.payments;
        this.purchases = response.data.purchases;
        this.date = `${this.date_from} to ${this.date_to}`;
      });
    },
    async yearlyanalysis() {
      await axios.get("/yearlyanalysis").then((response) => {
        this.yearlypayments = response.data.payments;
        this.yearlyexpenses = response.data.expenses;
        this.services = response.data.services;
      });
      const PaymentData = this.yearlypayments.map(e => ({ x: e.month, y: e.amount }));
      const ExpenseData = this.yearlyexpenses.map(e => ({ x: e.month, y: e.amount }));
      const servicesData = this.services.map(e => ({ x: e.name, y: e.count }));
      this.monthlypayments.series = [{ name: "Amount Paid", data: PaymentData }];
      this.monthlyexpenses.series = [{ name: "Expense", data: ExpenseData }];
      this.monthlyservices.series = [{ name: "Patients", data: servicesData }];
    },
  },
  mounted() {
    this.currentMonth = this.getCurrentMonth();
    this.todayDate = this.getDatePart();
    this.fetchSales({});
  },
};
</script>
